import React from "react";
import { useState, useEffect, useContext } from 'react';
import { Link, NavLink, useHistory } from 'react-router-dom';
import { Box } from '@mui/material';
import { Autocomplete, TextField } from '@mui/material';
import { ReactComponent as SearchIcon } from '../../assets/img/lupa.svg';
import { MyContext } from '../../context/MyContext';
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from '@mui/material/InputAdornment';
import api from '../../services/api';

export default function VeiculosSelect() {
  const [valueVeiculo, setValueVeiculo] = useState([]);
  const [inputValue, setInputValue] = useState([]);
  const [montadoras, setMontadoras] = useState([]);  
  const { produtos, setProdutos } = useContext(MyContext);
  const { paginaAtual, setPaginaAtual } = useContext(MyContext);
  const { paginaTotal,  setPaginaTotal } = useContext(MyContext);
  const { produtosOrdem } = useContext(MyContext);
  const { posicaoOrdem } = useContext(MyContext);
  const { ultimaPesquisaProdutos, setUltimaPesquisaProdutos } = useContext(MyContext);
 
  //setCookie('nafil_ultima_pesquisa','testcookie',7);  
  var ultimaPesquisaEfetuada = window.getCookie('nafil_ultima_pesquisa');
  if (ultimaPesquisaEfetuada) {
     setUltimaPesquisaProdutos(ultimaPesquisaEfetuada);    
  }
  else{
     setUltimaPesquisaProdutos("");    
  }
  let history = useHistory(); 
  let navigate = useHistory();  
    useEffect(() => {
       BuscarVeiculos();
    },[]); 


  function Pesquisar_Produtos(prod, skip, take = 15, produtosOrdem, posicaoOrdem) {    
    setPaginaAtual(1);    
    setUltimaPesquisaProdutos(prod);
    window.setCookie('nafil_ultima_pesquisa',prod,7);                
    history.push("/produtos");  
  }  

  function BuscarVeiculos(){
    api.get('Veiculos').then((response) => setMontadoras(response.data))
  }  

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      alignContent: 'center'
    }}>
      <Autocomplete
        id="pesquisar_produtos"
        sx={{ width: '100%', bgcolor: 'white', display: { xs: 'flex', sm: 'flex' } }}
        options={montadoras}
        autoHighlight
        //noOptionsText={'Digite o Veículo + Produto Desejado: CORSA PASTILHA FREIO...'}
        freeSolo={true}
        //value={value||""}
        value={ultimaPesquisaEfetuada||""}
        onChange={(event, newValue) => {
          setValueVeiculo(newValue);
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        renderOption={(props, option) => (
          <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            <img
              loading="lazy"
              width="22"
              src={option.imagemFile}
              srcSet={option.imagemFile}
              alt=""
            />
            {option.label}
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Pesquisar Produtos..."  
            style={{ textTransform: "uppercase !important" }}
            sx={{ input: { bgcolor: 'white', height: '15px' } }}
            onKeyDown={e => {
              if (e.key === 'Enter' && e.target.value) {                   
                if (ultimaPesquisaProdutos != e.target.value){                  
                  Pesquisar_Produtos(e.target.value, 1, 15, produtosOrdem, posicaoOrdem);                
                }                
              }
            }}            
            inputProps={{
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill            
              startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
              endAdornment: (
                <>
                  <IconButton  >
                    <SearchIcon />
                  </IconButton>
                </>
              ),
            }}
          />
        )}
      />
      <IconButton color="inherit" aria-label="add an alarm" size="large" onClick={(e)=>{Pesquisar_Produtos(document.getElementById('pesquisar_produtos').value , 1, 15, produtosOrdem, posicaoOrdem)}}>
        <SearchIcon style={{ color: "green" }} />
      </IconButton>      
    </div>    
 
  );
}